export default __webpack_public_path__ + "static/media/documentos.22734f05.png";